import { Select } from 'antd';

const { Option } = Select;

export default Option;
